import React from 'react'
import { useTranslation } from 'react-i18next'
import { directoryStrings } from '../../directory_i18n_mappings'
import { VerifiedIcon } from '../../../../shared/components/shared_components.styles'
import { Text } from '@amzn/storm-ui'
import { ClaimedByPartnerIcon, LegendContainer, LegendIconContainer, LegendsContainer } from './legends.styles'

export const Legends: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <LegendsContainer>
      <Text type={'h5'}>{t(directoryStrings.KEY)}</Text>
      <LegendContainer>
        <LegendIconContainer>
          <VerifiedIcon data-testid={'verified-icon'} />
        </LegendIconContainer>
        <Text>{t(directoryStrings.VERIFIED_BY_AMAZON)}</Text>
      </LegendContainer>
      <LegendContainer>
        <LegendIconContainer>
          <ClaimedByPartnerIcon data-testid={'claimed-by-partner-icon'} />
        </LegendIconContainer>
        <Text>{t(directoryStrings.SUPPORTED_BY_PARTNER)}</Text>
      </LegendContainer>
    </LegendsContainer>
  )
}
